import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Legend,
  ArcElement,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import {
  AreaChart,
  ResponsiveContainer,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Area,
  Label,
} from "recharts";
import useVendorCount from "../../CarrierAgreementMgmt/Vendor/hooks/useGetVendorCount";
import useVendor from "../../CarrierAgreementMgmt/Vendor/hooks/useVendor";
import useGetInactiveVendorCount from "../../CarrierAgreementMgmt/Vendor/hooks/useGetInactiveVendorCount";
import useGetInactiveTotalCount from "../../CarrierAgreementMgmt/Vendor/hooks/useGetInactiveTotalCount";
import useGetActiveTotalCount from "../../CarrierAgreementMgmt/Vendor/hooks/useGetActiveTotalCount";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Legend);

const VendorChart = () => {
  const { data: vendorCount } = useVendorCount();
  const { data: vendorData } = useVendor();
  const { data: inactiveTotalCountData } = useGetInactiveTotalCount();
  const { data: activeTotalCountData } = useGetActiveTotalCount();

  // Total of last 6 months of inactive and all active
  const totalOf = inactiveTotalCountData?.[0] + activeTotalCountData?.[0];

  // Vendor data per type
  const vendorTypeData = [
    {
      Name: "Security",
      Active: activeTotalCountData?.[1],
      Inactive: inactiveTotalCountData?.[1],
    },
    {
      Name: "Maintenance",
      Active: activeTotalCountData?.[2],
      Inactive: inactiveTotalCountData?.[2],
    },
    {
      Name: "Utilities",
      Active: activeTotalCountData?.[3],
      Inactive: inactiveTotalCountData?.[3],
    },
    {
      Name: "Property Management",
      Active: activeTotalCountData?.[4],
      Inactive: inactiveTotalCountData?.[4],
    },
    {
      Name: "Other",
      Active: activeTotalCountData?.[5],
      Inactive: inactiveTotalCountData?.[5],
    },
    {
      Name: "Business Licences and Permits",
      Active: activeTotalCountData?.[6],
      Inactive: inactiveTotalCountData?.[6],
    },
    {
      Name: "Leased Equipment",
      Active: activeTotalCountData?.[7],
      Inactive: inactiveTotalCountData?.[7],
    },
    {
      Name: "Servicing Dealer",
      Active: activeTotalCountData?.[8],
      Inactive: inactiveTotalCountData?.[8],
    },
    {
      Name: "Janitorial Service Type",
      Active: activeTotalCountData?.[9],
      Inactive: inactiveTotalCountData?.[9],
    },
  ];

  return (
    <div>
      <div className="grid grid-cols-2 items-center">
        <div className="grid sm:grid-cols-1">
          <h1 className="text-sm text-tertiary font-semibold">
            Vendor Status by Type
          </h1>
        </div>

        <div className="grid sm:grid-cols-1">
          <h4 className="text-right text-xs text-tertiary font-base">
            Total of{" "}
            <span className="text-base font-semibold">{totalOf || ""}</span>
          </h4>
        </div>
      </div>

      <div className="flex flex-auto justify-center mt-8">
        <ResponsiveContainer height={200}>
          <AreaChart
            data={vendorTypeData}
            margin={{
              top: 0,
              right: 20,
              left: -20,
              bottom: 40,
            }}
          >
            {/* <CartesianGrid strokeDasharray="3 3" /> */}
            <XAxis dataKey="Name" fontSize="9" angle={-30} dy={23} dx={-21} />
            <YAxis fontSize="9" />
            <Tooltip />
            <Area
              type="monotone"
              dataKey="Active"
              stroke="#0078D7"
              fill="#0078D7"
              fillOpacity="100%"
              stackId={0}
            />
            <Area
              type="monotone"
              dataKey="Inactive"
              stroke="#EC4899"
              fill="#EC4899"
              fillOpacity="100%"
              stackId={1}
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>

      <div className="flex items-center gap-2 m-1.5 justify-center flex-row">
        <div className="flex flex-row items-center">
          <div className="h-2 w-2 rounded-md bg-tabColorDarkBlue m-1" />
          <div className="inline-block text-xs4 font-normal">Active</div>
        </div>

        <div className="flex flex-row items-center">
          <div className="h-2 w-2 rounded-md bg-hsecondary m-1" />
          <div className="inline-block text-xs4 font-normal">Inactive</div>
        </div>
      </div>
    </div>
  );
};

export default VendorChart;
